export namespace Permissions {
  export enum Rbac {
      Default = 'Function',

      ApplicationAdd = 'Application.Add',
      ApplicationDelete = 'Application.Delete',
      ApplicationRead = 'Application.Read',
      ApplicationUpdate = 'Application.Update',

      ConsortiumView = 'Consortium.View',

      DashboardView = 'Dashboard.View',

      FunctionAdd = 'Function.Add',
      FunctionDelete = 'Function.Delete',
      FunctionRead = 'Function.Read',
      FunctionUpdate = 'Function.Update',

      ModuleAdd = 'Module.Add',
      ModuleDelete = 'Module.Delete',
      ModuleRead = 'Module.Read',
      ModuleUpdate = 'Module.Update',

      RoleAdd = 'Role.Add',
      RoleAssign = 'Role.Assign',
      RoleDelete = 'Role.Delete',
      RoleRead = 'Role.Read',
      RoleUpdate = 'Role.Update',
      RoleRemoveAssignment = 'Role.Remove.Assignment',
      RoleGlobalView = 'Role.Global.View',

      UserAdd = 'User.Add',
      UserDelete = 'User.Delete',
      UserRead = 'User.Read',
      UserUpdate = 'User.Update',
      UserChangePassword = 'User.Change.Password'
  }
}

export enum AppPermissions {
  DashboardView = 'Dashboard.View',
  DashboardPublishRaffle = 'Dashboard.Raffle.Publish',
  DashboardApproveRaffle = 'Dashboard.Raffle.Approve',
  DashboardModifyRaffle = 'Dashboard.Raffle.Modify',

  DashboardAssignPaper = 'Dashboard.Assign.Paper',
  DashboardGeneralReport = 'Dashboard.General.Report',
  DashboardBetType = 'Dashboard.Bet.Type',
  DashboardMonitoringF10 = 'Dashboard.Monitoring.F10',
  DashboardProducts = 'Dashboard.Products',
  DashboardServices = 'Dashboard.Services',
  DashboardTickets = 'Dashboard.Tickets',
  DashboardPaperWaste = 'Dashboard.Paper.Waste',

  AdministrationViewConsortiums = 'Consortium.View',
  AdministrationCreateConsortiums = 'Consortium.Create',
  AdministrationViewConsortiumDetails = 'Consortium.View.Details',
  AdministrationCreateAlliedConsortium = 'Consortium.Allied.Add',

  AdministrationViewGroups = 'Group.View',
  AdministrationCreateGroup = 'Group.Add',
  AdministrationEditGroup = 'Group.Modify',

  AdministrationCreateBank = 'Bank.Add',
  AdministrationEditBank = 'Bank.Modify',
  AdministrationViewBank = 'Bank.View',

  AdministrationViewTerminal = 'Terminal.View',
  AdministrationCreateTerminal = 'Terminal.Add',

  AdministrationViewGlobalUsers = 'User.Global.View',

  LotteryViewSchedule = 'Lottery.Schedule.View',
  LotteryModifySchedule = 'Lottery.Schedule.Modify',

  LotteryViewBankingMonitoring = 'Lottery.Banking.Monitoring.View',

  LotteryViewShortage = 'Lottery.Shortage.View',
  LotteryViewPaymentHistory = 'Lottery.Shortage.Payment.History',
  LotteryApproveShortage = 'Lottery.Shortage.Approve',
  LotteryCancelShortage = 'Lottery.Shortage.Cancel',
  LotteryAssignShortage = 'Lottery.Shortage.Assign',
  LotteryPayShortage = 'Lottery.Shortage.Payment',

  LotteryCancelTicket = 'Lottery.Ticket.Cancel',
  LotteryPayTicket = 'Lottery.Ticket.Pay',

  ServiceViewBalance = 'Service.Balance.View',
  ServiceAssignBalance = 'Service.Assign',

  RouteView = 'Route.View',

  RouteViewLooses = 'Route.View.Type.Loss',
  RouteViewProfits = 'Route.View.Type.Benefit',
  RouteViewLoosesAndProfits = 'Route.View.Type.Both',

  RouteAdd = 'Route.Add',
  RouteCreateTrips = 'Route.Trip',

  ReportViewUnpaidTickets = 'Report.Ticket.Unpaid',
  ReportViewCashReport = 'Report.Cash',
  ReportViewCashFlow = 'Report.Cash.Flow',

  ReportGeneratedCommissions = 'Report.Generated.Commissions',

  ReportViewAttendanceReport = 'Report.Attendance',
  ReportViewCollectionReport = 'Report.Collection',

  ReportViewConciliation = 'Report.Conciliation.View',
  ReportCreateConciliation = 'Report.Conciliation.Create',

  ConfigurationViewCommissionProfiles = 'Configuration.Generated.Commission.View',
  ConfigurationCreateCommissionProfiles = 'Configuration.Generated.Commission.Add',

  ConfigurationViewProfiles = 'Configuration.Profile.View',
  ConfigurationCreateProfiles = 'Configuration.Profile.Add',


  ConfigurationViewJobProfile = 'Configuration.Job.Profile.View',
  ConfigurationCreateJobProfile = 'Configuration.Job.Profile.Add',

  ConfigurationViewBankSettings = 'Configuration.Bank.Setting.View',
  ConfigurationCreateBankSettings = 'Configuration.Bank.Setting.Add',
  ConfigurationCreateEmail = 'Configuration.Add.Email',

  TransactionView = 'Transaction.View',
  TransactionAdd = 'Transaction.Add',

  TransactionAddAny = 'Transaction.Add.Any',
  TransactionAddUnique = 'Transaction.Add.Unique',

  TransactionConceptAdd = 'Transaction.Concept.Add',
  TransactionConceptView = 'Transaction.Concept.View',

  TerminalCashFlowView = 'Terminal.Cash.Flow.View',
  TerminalCashFlowCreate = 'Terminal.Cash.Flow.Create',

  MessagingView = 'Messaging.View',
  MessagingAdd = 'Messaging.Add',

  SupportTemplatesView = 'Support.Templates.View',
  SupportTemplatesAdd = 'Support.Templates.Add',
}

export enum ModuleIdentifier {
    Consortium,
    Service,
    User,
    Cash,
    Route,
    Dashboard,
    Settings
}

export enum AuthMode {
    All, // All permissions must be met
    Any, // At least one permission must be met
}
